// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"cc1aa67dae49c28fd82f","655":"2225ca69a4594bf6772e"}[chunkId] + ".js";
};